import apiUrl from '../../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import moment from 'moment'
import { BasicSelect,ModelSelect} from 'vue-search-select';
import Paginate from 'vuejs-paginate'

export default {
  name: 'creategroup',
  components: {
    BasicSelect,
    ModelSelect,
    Paginate,
    VueElementLoading,
    Multiselect
  },
  data: function() {
		return {
			cityList: [],
			cityid: '',
			groupType: '',
			routeMode: '',
			groupName: '',
			selectedHub: '',
			selectedHubid: '',
			selectedHubname: '',
			fetchedHubs: [],
			templateList: [],
			groupNumber: '',
      validateFlag: false,
			citySearch: '',
			citySearchStatus: false,
			citySearchName: '',
			gpstatus: '',
			gptemplateid: '',
			gpCityId: '',
			changestatus: '',
			resultCount: 0,
			isLoading: false,
			groupStatusModal: false,
			allocateHubmodal: false,
			selectedGroupid: '',
			useremail: '',
			showHubListModal: '',
			hubStatusModal: false,
			changestatusHub: '',
			showHubListModal: false,
			mappedHUbsList: [],
			mappedHubCount: 0,
			mappedHUbID: 0,
			mappedGroupId: 0,
			cityObjData: {
				value: "",
				text: ""
			},
			groupTypeObjData: {
				value: "",
				text: ""
			},
			modeObjData: {
				value: "",
				text: ""
			},
			hubListObjData: {
				value: "",
				text: ""
			},
			citySearchObjData: {
				value: "",
				text: ""
			},
			groupTypeList: [{
					value: '1',
					text: "City"
				},
				{
					value: '2',
					text: "Rest Of City"
				},
				{
					value: '3',
					text: "RTO"
				}, {
					value: '4',
					text: "Rest of RTO"
				},
			],
			modeList: [{
					value: '1',
					text: "Surface"
				},
				{
					value: '2',
					text: "Air"
				},

			],
			pageCount: 0,
			pageNo: 0,
			limit: 10,
			totalRows: 0,
      hubzoneid: '',
      listHubZoneData: [],
      destinationhub: {},
      HubArr: [],
      destData: [],
      connectionDestList: [],
      addmodalShow: false,
      checkAllHub:false,
      totalmappedhubs: 0,
      connDestLoading:false,
      zoneLoading:'',
      resultgroupid:'',
      groupLoading:false,
      disabled: false,
      modelArr:[],
      allHubData:[],
      checked:[],
      clickedMB:false
		}
	},

	created: function() {},
	computed: {},
  filters: {
    moment: function(date) {
      if (date == null || date == '')
        return '--'
      return moment(date).format('DD-MM-YYYY');
    }
  },
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes             = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext         = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail        = JSON.parse(plaintext);
    this.useremail        = userdetail[0].email;

		this.getCityList();
    this.getHubZoneData();
    this.getAllHubs();
  },

  methods: {
    selectedCity(cityData) {
        this.cityObjData = cityData;
        this.cityid = cityData.value;
        this.setGroupName();
        this.groupNumber= '';
        this.resetDes();
      },

      selectedGroupType(groupData) {
        this.groupTypeObjData = groupData;
        this.groupType = groupData.value;
        this.setGroupName();
        this.groupNumber= '';
        this.resetDes();
      },

      selectedRouteMode(routeData) {
        this.modeObjData = routeData;
        this.routeMode = routeData.text;
        this.groupNumber= '';
        this.resetDes();
      },

      selectedHubName(hubData) {
        this.hubListObjData = hubData;
        this.selectedHubid = hubData.value;
        var splitVal = hubData.text.split(" ");
        this.selectedHubname = splitVal[0];
      },

      selectedCitySearch(searchCityData) {
        this.citySearchObjData = searchCityData;
        this.citySearch = searchCityData.value;
        this.citySearchName = searchCityData.text;
      },

      setGroupName() {
        if (this.cityid != "" && this.groupType != "") {
          if (this.groupType == 4) {
            this.groupName = 'Rest of ' + this.cityObjData.text + ' RTO';
          } else {
            this.groupName = this.groupTypeObjData.text + ' ' + this.cityObjData.text;
          }
        }
      },

      getStatusRowData(data) {
        this.groupStatusModal = true;
        this.gptemplateid = data.groupid;
        this.gpstatus = data.isactive;
        this.gpCityId = data.cityid;
        if (data.isactive == true) {
          this.changestatus = 'De-Activate'
        } else {
          this.changestatus = 'Activate'
        }
      },

      closeStatusGroupModal() {
        this.groupStatusModal = false
      },

      changeGroupTemplateStatus() {
        this.isLoading = true;
        if (this.changestatus == 'De-Activate') {
          var newStatus = false;
        } else {
          var newStatus = true;
        }
        this.input = ({
          groupId: this.gptemplateid,
          cityId: this.gpCityId,
          isActive: newStatus,
          createdby: this.useremail,
        })

        axios({
            method: 'PUT',
            'url': apiUrl.api_url_hubops + 'deallocateGroup',
            'data': this.input,
            headers: {
              'authorization': 'authkey xB84JJ89Hd25',
            }
          })
          .then((result) => {
            this.isLoading = false;
            if (result.data.ResultCode == 500) {
              this.$alert(result.data.ReturnMessage, "", "error");
            }
            if (result.data.ResultCode == 101) {
              this.$alert(result.data.ReturnMessage, "", "error");
            }
            if (result.data.ResultCode == 100) {
              this.$alert('Template Status Changed Successfully', "", "success");
            }
            this.groupStatusModal = false;
            this.getGroupTemplates();
          })
          .catch((httpException) => {
            console.error('exception is:::::::::', httpException)
          })
      },

      getGroupTemplates() {
        this.groupLoading=true;
        if (this.citySearch == null || this.citySearch == undefined || this.citySearch == '') {
          return false;
        }
        if (this.citySearch != "") {

          this.totalRows = 0
          this.resultCount = 0;
          this.templateList = [];
          this.input = ({})
          axios({
              method: 'GET',
              // legacy backup: getCityWiseGroups
              // 'url': apiUrl.api_url_hubops + 'getCityWiseGroups?offset=' + this.pageNo + '&limit=' + this.limit + '&cityId=' + this.citySearch + '&isActive=' + this.citySearchStatus,
              'url': apiUrl.api_url_hubops + 'groups?offset=' + this.pageNo + '&limit=' + this.limit + '&cityId=' + this.citySearch + '&isActive=' + this.citySearchStatus + '&includeTotalCount=true',
              'data': this.input,
              headers: {
                'authorization': 'authkey xB84JJ89Hd25',
              }
            })
            .then(result => {
              this.groupLoading=false;
              if (result.data.ResultCode == 100) {
                this.templateList = result.data.ResponseData
                this.resultCount = result.data.ResponseData.length
                this.totalRows = result.data.TotalCount
                if (this.totalRows < this.limit) {
                  this.pageCount = 1
                } else {
                  this.pageCount = Math.ceil(this.totalRows / this.limit);
                }
              } else {
                this.templateList = 0
                this.resultCount = 0
                this.groupLoading=false;
                this.$alert(result.data.ReturnMessage, "", "error");
              }
            }, error => {
              this.groupLoading=false;
              console.error(error)
            })
        } else {
          this.$alert("Please Select Any City", "", "error");
          return false;
        }
      },

      getPaginationData(pageNum) {
        this.pageNo = (pageNum - 1)
        this.getGroupTemplates()
      },

      getCityList() {
        this.isLoading = true;
        var i = 0;
        this.input = ({})
        axios({
            method: 'POST',
            'url': apiUrl.api_url_hubops + 'allcity/get',
            'data': this.input,
            headers: {
              'authorization': 'authkey xB84JJ89Hd25',
            }
          })
          .then(result => {
            this.isLoading = false;
            var cityList = result.data.ResponseData
            for (i = 0; i < cityList.length; i++) {
              this.cityList.push({
                value: cityList[i].cityid,
                text: cityList[i].cityname
              })
            }
          }, error => {
            console.error(error)
          })
      },

      getAllHubs() {
  			this.isLoading = true;
  			var i = 0;
  			this.input = ({})
  			axios({
  					method: 'POST',
  					'url': apiUrl.api_url_hubops + 'hubservicecenter/list',
  					'data': this.input,
  					headers: {
  						'authorization': 'authkey xB84JJ89Hd25',
  					}
  				})
  				.then(result => {
  					this.isLoading = false;
  					var fetchedHubs = result.data.ResponseData
  					for (i = 0; i < fetchedHubs.length; i++) {
  						this.fetchedHubs.push({
  							value: fetchedHubs[i].HubID,
  							text: fetchedHubs[i].HubName + ' (' + fetchedHubs[i].HubID + ')'
  						})
  					}
  				}, error => {
  					console.error(error)
  				})

  		},

      getHubMappedListData(data) {
        this.isLoading = true;
        this.input = ({})
        axios({
            method: 'GET',
            // legacy backup: fetchGroupsAllocatedDestinationByGroupId
            // 'url': apiUrl.api_url_hubops + 'fetchGroupsAllocatedDestinationByGroupId?groupId=' + data.groupid,
            'url': apiUrl.api_url_hubops + 'groups?groupId=' + data.groupid + '&include=templateDestinations&responseShape=destinationsOnly',
            'data': this.input,
            headers: {
              'authorization': 'authkey xB84JJ89Hd25',
            }
          })
          .then(result => {
            this.isLoading = false;
            if (result.data.ResultCode == 500) {
              this.$alert(result.data.ReturnMessage, "", "error");
            }
            if (result.data.ResultCode == 101) {
              this.$alert(result.data.ReturnMessage, "", "error");
              this.resultCountMappedHubs = 0;
              this.mappedHUbsList = [];
            }
            if (result.data.ResultCode == 100) {
              this.mappedHUbsList = result.data.ResponseData;
              this.mappedHubCount = result.data.ResponseData.length;
              this.showHubListModal = true;
            }

          }, error => {
            console.error(error)
          })
      },

      getStatusHublistData(data) {
        this.hubStatusModal = true;
        this.showHubListModal = false;
        this.mappedHUbID = data.destinationhubid;
        this.mappedGroupId = data.groupid;

        if (data.isactive == true) {
          this.changestatusHub = 'De-Activate'
        } else {
          this.changestatusHub = 'Activate'
        }
      },

      changeMappedHubStatus() {
        this.isLoading = true;
        if (this.changestatusHub == 'De-Activate') {
          var newStatus = false;
        } else {
          var newStatus = true;
        }
        this.input = ({
          groupId: this.mappedGroupId,
          destinationhubId: this.mappedHUbID,
          isActive: newStatus,
        })
        axios({
            method: 'PUT',
            'url': apiUrl.api_url_hubops + 'deAllocateGroupMapByHubId',
            'data': this.input,
            headers: {
              'authorization': 'authkey xB84JJ89Hd25',
            }
          })
          .then((result) => {
            this.isLoading = false;
            if (result.data.ResultCode == 500) {
              this.$alert(result.data.ReturnMessage, "", "error");
            }
            if (result.data.ResultCode == 101) {
              this.$alert(result.data.ReturnMessage, "", "error");
            }
            if (result.data.ResultCode == 100) {
              this.$alert('Hub Status Changed Successfully', "", "success");
            }
            this.showHubListModal = false;
            this.hubStatusModal = false;
          })
          .catch((httpException) => {
            console.error('exception is:::::::::', httpException)
          })
      },

      openHubMapModal(data) {
        this.selectedGroupid = data.groupid;
        this.allocateHubmodal = true;
      },

      closeMapHubWithGroup() {
        this.allocateHubmodal = false;
        this.hubListObjData = {
          value: "",
          text: ""
        }
      },

      saveMapHubWithGroup() {
        if (this.selectedHubid != "") {
          this.isLoading = true;
          this.input = ({
            groupid: this.selectedGroupid,
            destinationhubid: this.selectedHubid,
            hubname: this.selectedHubname,
            createdby: this.useremail,

          })
          axios({
              method: 'POST',
              'url': apiUrl.api_url_hubops + 'allocateHubToGroupTemplate',
              'data': this.input,
              headers: {
                'authorization': 'authkey xB84JJ89Hd25',
              }
            })
            .then(result => {
              this.isLoading = false;
              if (result.data.ResultCode == 500) {
                this.$alert(result.data.ReturnMessage, "", "error");
              }
              if (result.data.ResultCode == 101) {
                this.$alert(result.data.ReturnMessage, "", "error");
              }
              if (result.data.ResultCode == 100) {
                this.$alert(result.data.ReturnMessage, "", "success");
              }
              this.allocateHubmodal = false;
              this.hubListObjData = "";
              this.selectedHubid="";
            }, error => {
              console.error(error)
            })
        } else {
          this.$alert("Please Select Any HUb", "", "error");
          return false;
        }
      },

      closeStatusHubModal() {
        this.hubStatusModal = false;
      },

      closeshowHubListModal() {
        this.showHubListModal = false
        $(document.body).removeClass("modal-open");
        $(".modal-backdrop").remove();
      },

      resetForm() {
        this.routeMode = '';
        this.cityid = '';
        this.groupType = '';
        this.groupName = '';
        this.groupNumber = '';
        this.cityObjData = {
          value: "",
          text: ""
        };
        this.groupTypeObjData = {
          value: "",
          text: ""
        };
        this.modeObjData = {
          value: "",
          text: ""
        };
        this.$validator.reset();
        this.addmodalShow= false;
        this.hubzoneid= '',
        this.zoneLoading= '',
        this.resultgroupid=''
        this.groupLoading=false;
        this.disabled= false;
        this.resetDes();
      },

      onSubmitSearch: function() {
        var self = this
        this.$validator.validateAll('form-1').then((result) => {
          if (!result) {
            return false;
          }
        }).catch(() => {
          console.log('errors exist')
        });
      },


      onSubmit: function() {
        this.$validator.validateAll('form')
            .then((result) => {
              if (!result) {
                this.clickedMB=false;
                return false;
              }else {
                  this.hubzoneid= '';
                  this.resetDes();
                  this.getDestinationsByConnection();
                }
              }).catch(() => {
              console.log('errors exist')
            });
        },

      closeStatusModal() {
        this.addmodalShow = false
      },

      getDestinationsByConnection() {

        this.connDestLoading    = true;
        this.connectionDestList = [];
        this.destData           = [];
        this.HubArr             = [];
        this.totalmappedhubs    = 0;
        this.checkAllHub        = false;
        this.disabled           = false;
        this.clickedMB=true;

        axios({
            method: 'GET',
            'url': apiUrl.api_url_hubops + "fetchGroupTemplateDetails?cityid="+this.cityid+ '&routemode=' + this.routeMode + '&grouptype=' + this.groupType +(this.hubzoneid ? "&hubzoneid="+this.hubzoneid : ''),
            headers: {
              'Authorization': "authkey xB84JJ89Hd25"
            }
          })
          .then(result => {
            if (result.data.ResultCode == 100) {
              let j=0; let list=[]; let dlist=[]; let clen=0;
              if(result.data.GroupNo){
                this.disabled= true;
                let num = result.data.GroupNo.replace(/[^0-9]/g, '');
                this.groupNumber= parseInt(num,10).toString();
              }
              let hData = result.data.ResponseData;
              for (var i = 0; i < hData.length; i++) {
                if(j<4){
                  list.push({
                    hubId:hData[i].HubID,
                    hubName:hData[i].HubName,
                    isHubDisabled:hData[i].isHubDisabled
                  });
                }else{
                  dlist.push(list);
                  list=[]
                  list.push({
                    hubId:hData[i].HubID,
                    hubName:hData[i].HubName,
                    isHubDisabled:hData[i].isHubDisabled
                  });
                  j=0;
                }
                j++;

                if(hData[i].isHubAllocated==true){
                  (this.HubArr.indexOf(hData[i].HubID) === -1 && hData[i].isHubDisabled==false) ? this.HubArr.push(hData[i].HubID):'';
                  this.checked[hData[i].HubID] = true;
                  clen++;
                }

                this.destData.push({
                  hubId:hData[i].HubID,
                  hubName:hData[i].HubName,
                  isHubDisabled:hData[i].isHubDisabled
                });

                const allH = this.allHubData.some(el => el.hubId === hData[i].HubID);
                if (!allH) {
                  this.allHubData.push({
                    hubId:hData[i].HubID,
                    hubName:hData[i].HubName
                  });
                }
              }

              this.modelArr = (this.modelArr.length>0) ? this.modelArr : this.HubArr;

              dlist.push(list);

              this.connectionDestList = dlist;
              this.totalmappedhubs    = result.data.TotalAllocatedCount;
              this.resultgroupid      = result.data.GroupId ;
              if(clen === this.destData.length) this.checkAllHub = true;
            }else{
              this.$alert(result.data.ReturnMessage, "", "error");
            }
            this.connDestLoading=false;
          }, error => {
            this.connDestLoading=false;
            console.error(error)
          })
      },

      checkHub() {
        if(typeof InstallTrigger !== 'undefined' == true){ this.checkAllHub = !this.checkAllHub; }

        if (this.checkAllHub) {

          for (var i = 0; i < this.destData.length; i++) {
            if(this.destData[i].isHubDisabled==false) {
              this.checked[this.destData[i].hubId]=true;
              this.modelArr.indexOf(this.destData[i].hubId) === -1 ? this.modelArr.push(parseInt(this.destData[i].hubId)):'';
            }
          }
        }else{

          let arr=[];
          for (var i = 0; i < this.destData.length; i++) {
            if(this.destData[i].isHubDisabled==false) {
              this.checked[this.destData[i].hubId]=false;
              arr.push(this.destData[i].hubId);
            }
          }

          this.modelArr = this.modelArr.filter(val => !arr.includes(val));
        }
      },

       updateCheckDest(event){
         this.checked[event.target.id] = event.target.checked;

         if(event.target.checked==false){
          this.modelArr = this.modelArr.filter(el => el != event.target.id)

         }else{
          this.modelArr.indexOf(event.target.id) === -1 ? this.modelArr.push(parseInt(event.target.id)):'';
         }

         this.checkAllHub = (this.destData.length === this.modelArr.length) ? true : false;
       },

      onSubmitHub: function(elem) {
       this.$validator.validateAll('form').then((result) => {
         if (!result) {
           return false;
         }else if (!this.groupNumber ) {
           this.$alertify.error('Group Number should not be empty'); return false;
         }else{
         this.addmodalShow = true
         }
       }).catch(() => {});
     },

      mapMultipleHubsToConnection() {
       this.connDestLoading = true;

       let nArr = this.allHubData.filter((elem) => this.modelArr.find((el) => elem.hubId == el));

       this.input = ({
         groupid:parseInt( this.resultgroupid ),
         cityid: this.cityid,
         routemode: this.routeMode,
         grouptype: parseInt(this.groupType),
         groupname: this.groupName,
         groupNo: this.groupNumber,
        hubIdAndHubName: nArr,
        createdby: this.useremail
       })
       axios({
           method: 'POST',
           'url': apiUrl.api_url_hubops + "createGroupAndAllocateLocationsToGroupTemplate_V1",
           'data': this.input,
           headers: {
             'Authorization': "authkey xB84JJ89Hd25"
           }
         })
         .then(result => {
           if (result.data.ResultCode == 100) {
             this.$alert(result.data.ReturnMessage, "", "success");
             this.hubzoneid = '';
             this.allHubData= [];
             this.modelArr= [];
             this.checked= [];
             this.getDestinationsByConnection();
           } else {
             this.$alert(result.data.ReturnMessage, "", "error");
           }
           this.connDestLoading = false;
         }, error => {
           this.connDestLoading = false;
           console.error(error)
         })
     },

      takeAction() {
      this.mapMultipleHubsToConnection();
     },

     getHubZoneData() {

       this.zoneLoading = 'Loading Zone...';
       this.input = ({})
       axios({
           method: 'POST',
           'url': apiUrl.api_url_hubops + 'hubzone/list',
           'data': this.input,
           headers: {
             'authorization': 'authkey xB84JJ89Hd25',
           }
         })
         .then(result => {
           if (result.data.ResultCode == 100) {
             let listHubZoneData = result.data.ResponseData;
             for (let i = 0; i < listHubZoneData.length; i++) {
               this.listHubZoneData.push({
                 value: listHubZoneData[i].hubzoneid,
                 text: listHubZoneData[i].hubzonename
               })
             }
           }
           this.zoneLoading = '';
         }, error => {
           this.zoneLoading = '';
           console.error(error);
         })
     },

    SelectZone() {
        this.getDestinationsByConnection();
    },

    resetDes(){
      this.HubArr= [];
      this.destData= [];
      this.allHubData= [];
      this.modelArr= [];
      this.checked= [];
      this.connectionDestList= [];
      this.connDestLoading = false;
      this.checkAllHub= false;
      this.totalmappedhubs= 0;
      this.clickedMB=false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/components/group/creategroup_new/creategroup_new.js